export enum PROMO_TYPES {
  SPORTS = 'SPORTS',
  RACING = 'RACING',
}
